export default __webpack_public_path__ + "static/media/collectieve-effectiviteit.3adf4727.svg";